import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { CreateApiKeyRequest, UpdateApiKeyRequest } from '@ytclip/shared'
import { toast } from 'sonner'
import { ApiRequestError } from '@/lib/api-client.ts'
import { createApiKey, deleteApiKey, fetchApiKeys, updateApiKey } from './api.ts'

const KEYS_QUERY = ['api-keys'] as const

function describe(error: unknown, fallback: string): string {
  return error instanceof ApiRequestError ? error.message : fallback
}

export function useApiKeys() {
  return useQuery({ queryKey: KEYS_QUERY, queryFn: fetchApiKeys })
}

export function useCreateApiKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (body: CreateApiKeyRequest) => createApiKey(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: KEYS_QUERY })
    },
    onError: (error) => toast.error(describe(error, 'Gagal membuat API key')),
  })
}

export function useUpdateApiKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: { token: string; body: UpdateApiKeyRequest }) =>
      updateApiKey(input.token, input.body),
    onSuccess: () => {
      toast.success('API key diperbarui')
      void queryClient.invalidateQueries({ queryKey: KEYS_QUERY })
    },
    onError: (error) => toast.error(describe(error, 'Gagal memperbarui API key')),
  })
}

export function useDeleteApiKey() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (token: string) => deleteApiKey(token),
    onSuccess: () => {
      toast.success('API key dihapus')
      void queryClient.invalidateQueries({ queryKey: KEYS_QUERY })
    },
    onError: (error) => toast.error(describe(error, 'Gagal menghapus API key')),
  })
}
